import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import Table, { ColumnProps } from 'antd/lib/table'
import { AuditFilterStore } from './AuditFilterStore'
import { AuditStatus } from '@getgreenline/homi-shared'
import { Link } from 'react-router'
import { Routes } from '../../../../../constants/Routes'
import { Tag, Empty } from 'antd'
import moment from 'moment'
import Highlighter from 'react-highlight-words'
import { CurrentCompanyStore } from '../../../../../stores/CurrentCompanyStore'

interface AuditTableRecord {
  title: JSX.Element
  location: string
  startedBy: string
  created: string
  completed: string
  status: JSX.Element
}

interface Props {
  currentCompanyStore?: CurrentCompanyStore
  auditFilterStore: AuditFilterStore
}

const columns: ColumnProps<AuditTableRecord>[] = [
  { title: 'Title', dataIndex: 'title', key: 'title' },
  { title: 'Location', dataIndex: 'location', key: 'location' },
  { title: 'Started by', dataIndex: 'startedBy', key: 'startedBy' },
  { title: 'Created', dataIndex: 'created', key: 'created' },
  { title: 'Completed', dataIndex: 'completed', key: 'completed' },
  { title: 'Status', dataIndex: 'status', key: 'status', width: 120 },
]

@inject('currentCompanyStore')
@observer
export class AuditTableList extends Component<Props> {
  renderAuditStatusTag(auditStatus: AuditStatus): JSX.Element {
    switch (auditStatus) {
      case 'completed':
        return <Tag color='green'>Completed</Tag>
      case 'cancelled':
        return <Tag color='red'>Cancelled</Tag>
      default:
        return <Tag>Pending</Tag>
    }
  }

  splitSearchWords(words?: string): string[] {
    if (!words) return []
    return [...words.split(' ')]
  }

  get tableDataSource(): AuditTableRecord[] {
    const { paginatedAudits } = this.props.auditFilterStore
    const highlightedSearchText = this.splitSearchWords(
      this.props.auditFilterStore.isFiltered ? this.props.auditFilterStore.searchText : '',
    )
    const highlightedSearchId = this.splitSearchWords(
      this.props.auditFilterStore.isFiltered ? this.props.auditFilterStore.searchId : '',
    )

    const auditData = !paginatedAudits
      ? []
      : paginatedAudits.data.map((audit) => ({
          key: audit.id,
          title: (
            <div className='audit-table-title'>
              <Link
                to={Routes.EDIT_INVENTORY_AUDIT(
                  this.props.currentCompanyStore!.company!.id,
                  audit.id,
                )}
              >
                <Highlighter
                  highlightClassName='highlighted-text'
                  searchWords={highlightedSearchText}
                  autoEscape
                  textToHighlight={audit.title}
                />
              </Link>
              <p style={{ marginBottom: 0, fontSize: 12 }}>
                <Highlighter
                  highlightClassName='highlighted-text'
                  searchWords={highlightedSearchId}
                  autoEscape
                  textToHighlight={audit.id}
                />
              </p>
            </div>
          ),
          location: audit.locationName,
          startedBy: audit.startingUserName,
          created: moment(audit.createDate).format('MMM D, YYYY h:mm a'),
          completed: audit.completeDate
            ? moment(audit.completeDate).format('MMM D, YYYY h:mm a')
            : '-',
          status: this.renderAuditStatusTag(audit.status),
        }))

    return auditData
  }

  render() {
    return (
      <Table
        className='audit-table no-background-table show-horizontal-scrollbar'
        rowClassName={() => 'background-white'}
        scroll={{ x: 'max-content' }}
        columns={columns}
        dataSource={this.tableDataSource}
        pagination={false}
        locale={{ emptyText: <Empty description='No audits' /> }}
        loading={this.props.auditFilterStore.isLoading}
      />
    )
  }
}
